import { NamedSchemaError, SchemaFailureInfo } from "@reduxjs/toolkit/query";

export function logSchemaFailure(error: NamedSchemaError, info: SchemaFailureInfo) {
  console.group(`Schema failure: ${error.schemaName}`);
  console.error("Endpoint:", info.endpoint);
  console.error("Type:", info.type);
  console.error("Arg:", info.arg);
  console.error("Raw value:", error.value);
  console.error("Issues:", error.issues);
  console.groupEnd();
}
